import {
    RECEIVE_PENSION_CONTRIBUTIONS_SUMMARY,
    REQUEST_PENSION_CONTRIBUTIONS_SUMMARY,
} from '../actions/pension-contributions-summary'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_PENSION_CONTRIBUTIONS_SUMMARY:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_PENSION_CONTRIBUTIONS_SUMMARY: {
            return { ...state, ...data, isFetching: false }
        }

        default:
            return state
    }
}
